import React from 'react';
import { useGoogleMaps } from "react-hook-google-maps";
// import { classNames } from './shared/Utils';
const CatchCard = ({ newCatchInfo, catchTime, fisherInfo }) => {

    let lat = parseFloat(newCatchInfo.latitude);
    let long = parseFloat(newCatchInfo.longitude);
    const { ref } = useGoogleMaps(
        "AIzaSyBWZUOHp68NfknPmjIcyAPC4YDunH-qOns",
        {
            center: { lat: lat, lng: long },
            zoom: 3
        }
    );

    return (
        <div className="overflow-y-auto mx-5 mb-5 px-10 py-8  rounded-3xl bg-white shadow-2xl sm:p-10">
            <div className="sm:flex justify-between">
                <div>
                    <div className="sm:flex rounded-xl bg-gray-100 p-5">
                        <div className="w-52">
                            <p className="text-xl  text-blue-700 font-sans font-light">Catch Info</p>
                            <p className="text-xl  text-gray-500 font-sans font-semibold">{catchTime.date}</p>
                            <p className="text-xl text-gray-500 font-sans font-normal"> {catchTime.time}</p>
                        </div>
                        <div className="px-5">
                            <p className="text-lg text-gray-500  font-sans font-light">
                                Species</p>
                            <p className="text-3xl pb-2 text-gray-500 font-sans font-bold">
                                {newCatchInfo.species}</p>
                            <p className="text-lg text-gray-500 font-sans font-light">
                                Weight</p>
                            <p className="text-3xl pb-2 text-gray-500 font-sans font-bold">
                                {newCatchInfo.weight} kg</p>
                            <p className="text-lg  text-gray-500 font-sans font-light">
                                Location (Long, Lat)</p>
                            {/* <p className="text-3xl text-gray-500 font-sans font-bold">
                                Pangasinan</p> */}
                            <p className="text-xl text-gray-500 font-sans font-semibold">
                                {parseFloat(newCatchInfo.longitude).toFixed(2)}, {parseFloat(newCatchInfo.latitude).toFixed(2)}</p>
                        </div>
                    </div>

                    <div className="sm:flex rounded-xl bg-gray-100 p-5 mt-5">

                        <div className="w-52">
                            <p className="text-xl text-blue-700 font-sans font-light">
                                Fisherman Info</p>
                        </div>
                        <div className="px-5">
                            <p className="text-lg text-gray-500 font-sans font-light">
                                Name</p>
                            <p className="text-3xl pb-2 text-gray-500 font-sans font-bold">
                                {fisherInfo.lastName}, {fisherInfo.firstName}</p>
                            <p className="text-lg text-gray-500 font-sans font-light">
                                Vessel No.</p>
                            <p className="text-3xl pb-2 text-gray-500 font-sans font-bold">
                                {fisherInfo.vesselNum}</p>
                            {/* <p className="text-lg text-gray-500 font-sans font-normal">
                                Registration Status </p>
                            <p  className={classNames(
          "px-3 py-1 text-center uppercase font-bold text-lg rounded-full shadow-sm mb-5 w-1/3",
          fisherInfo.regStatus.startsWith("active") ? "bg-blue-100 text-green-700" : null,
          fisherInfo.regStatus.startsWith("expired") ? "bg-red-100 text-yellow-700" : null,
          
        )}>
                                {fisherInfo.regStatus}</p> */}
                            <p className="text-lg text-gray-500 font-sans font-light">
                                Contact No.</p>
                            <p className="text-3xl text-gray-500 font-sans font-bold">
                                {fisherInfo.mobileNum}</p>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="mx-10 my-2">
                        <img src={newCatchInfo.src} width="350px" alt="catch"></img>
                    </div>
                    <div className=" mx-10 mt-10 rounded-2xl align-center" ref={ref} style={{ width: 400 }} />
                </div>
            </div>
        </div>
    );

};

export default CatchCard;